import React from 'react';
import './TextSection.scss';
import { useSystemDevice } from '../../hooks/useSystemDevice';

export interface Props {
  className?: string;
  text?: string;
  title?: string;
}

const KiteCupTextSection: React.FC<Props> = (props) => {
  const systemDevice = useSystemDevice();
  const scope = 'KiteCupTextSection';

  const className = [scope, `${scope}--${systemDevice}`, props.className]
    .filter((className) => className)
    .join(' ');

  return (
    <section className={className}>
      {props.title && <div className={`${scope}-title`}>{props.title}</div>}
      {props.text && (
        <div className={`${scope}-text`}>
          <div className={`${scope}-textWidthLimiter`}>{props.text}</div>
        </div>
      )}
    </section>
  );
};

export default KiteCupTextSection;
